import { render, staticRenderFns } from "./CertificateCard.vue?vue&type=template&id=63b1ded2&scoped=true&"
import script from "./CertificateCard.vue?vue&type=script&lang=js&"
export * from "./CertificateCard.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCard.vue?vue&type=style&index=0&id=63b1ded2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1ded2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VRow})
